import type { RouteSegment } from '../lib/route';
import { shadeColor } from './colors';

/**
 * Barra orizzontale del percorso: ogni tratto ha larghezza proporzionale
 * alla lunghezza e colore in base all'ombra (arancio sole → indaco ombra).
 */
export function ShadeTimeline({
  segments,
  progress,
  compact = false,
}: {
  segments: RouteSegment[];
  /** 0..1: posizione corrente lungo il percorso (navigazione) */
  progress?: number;
  compact?: boolean;
}) {
  const total = segments.reduce((s, x) => s + x.lengthM, 0) || 1;
  const shaded = segments.reduce((s, x) => s + x.lengthM * x.shade, 0) / total;
  return (
    <div
      className={`timeline${compact ? ' timeline--compact' : ''}`}
      role="img"
      aria-label={`Ombra lungo il percorso: ${Math.round(shaded * 100)}% complessivo`}
    >
      <div className="timeline__bar">
        {segments.map((s, i) => (
          <span
            key={i}
            className={`timeline__seg${s.covered ? ' timeline__seg--covered' : ''}`}
            style={{ flex: s.lengthM / total, background: shadeColor(s.shade) }}
          />
        ))}
        {progress !== undefined && (
          <span
            className="timeline__cursor"
            style={{ left: `${Math.max(0, Math.min(1, progress)) * 100}%` }}
          />
        )}
      </div>
      {!compact && (
        <div className="timeline__axis t-cap">
          <span>Partenza</span>
          <span>Arrivo</span>
        </div>
      )}
    </div>
  );
}
